import React, { Component } from 'react'
import AdditionalDetailsForm from '../tags/AdditionalDetailsForm'
import { getSonePersonalDetails, putSonePersonalDetails, getReferences, getStudentProgress } from '../../services/vu'
import { getHelperTextForPage } from '../../services/reservoir'
import { getStepByIndex, getStepIndexByUrl, updateDBStepProgress, updateStepProgress } from '../../helpers/steps'
import DrupalModal from '../tags/Modals/DrupalModal'
import Country from '../../enums/Country'
import Loading from '../tags/Loading'
import { getCourseId } from '../../helpers/course'
import { differenceInSeconds } from 'date-fns'
import { getLastPageAccessTime } from '../../helpers/gtm'
import ResidencyType from '../../enums/ResidencyType'
import { getAttributeCourseStaticInfo } from '../../helpers/enrolment'
import { Info } from '@mui/icons-material'

export default class AdditionalDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      formLoaded: false,
      saving: false,
      form: {
        disabilityIndicator: '',
        disability: [],
        contactInd: '',
        countryOfBirth: '',
        yearOfArrival: '',
        englishOnlyAtHome: '',
        language: '',
        year12InAustralia: '',
        residencyPostcodeYear12: '',
        residencySuburbYear12: '',
        countryOfResidenceYear12: '',
        parentGuardian1EduLvl: '',
        parentGuardian2EduLvl: '',
        isSecondaryEducationCompleted: '',
        yearLeftSchool: '',
        dateOfBirth: '',
        highestPriorEducationAchieved: '',
        levelLeftSchool: '',
        indigenousOrigin: '',
        stuCitizenCd: '',
        visaQuestionResponse: '',
        visaType: '',
        visaSubType: '',
        isVisaRequired: false,
        isVisaAlreadySubmitted: false,
        isATSIResponded: false,
        offshoreFlag: getAttributeCourseStaticInfo('isOffshoreFlag')
      },
      personalDetails: {
        studentId: ''
      },
      soneLevelLeftSchoolList: [],
      countryCodes: [],
      topCallout: '',
      prefilledData: [],
      isModalOpen: false
    }
  }

  componentDidMount() {
    getHelperTextForPage('Additional Details').then(helperText => {
      this.setState({
        topCallout: helperText.data.length > 0 ? helperText.data[0].attributes.body.value : this.state.topCallout
      })
    })

    Promise.all([getSonePersonalDetails(), getReferences()]).then(([personalDetails, { soneCountryCodeList = [], soneParentsEducationLevelList = [], soneLevelLeftSchoolList = [] }]) => {
      this.setState({
        form: {
          ...this.state.form,
          ...this.mergeStudentDetails(personalDetails, soneParentsEducationLevelList, soneLevelLeftSchoolList, soneCountryCodeList)
        },
        personalDetails: personalDetails,
        countryCodes: soneCountryCodeList,
        soneLevelLeftSchoolList: soneLevelLeftSchoolList,
        formLoaded: true
      })
    })

    this.trackPageView()
  }

  trackPageView = () => {
    getStudentProgress(getCourseId()).then(progress => {
      const processId = progress && progress.id ? progress.id : undefined

      const lastPageAccessTime = getLastPageAccessTime()
      const pageAccessTime = new Date()

      window.dataLayer.push({
        event: 'custom.form.step.view',
        group: 'Enrol',
        processId: processId,
        step: {
          sequence: 3,
          label: 'Additional details',
          variation: undefined
        },
        info: {
          time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
        },
        data: {
          value: undefined,
          courseId: getCourseId()
        }
      })

      sessionStorage.setItem('LAST_PAGE_ACCESS_TIME', JSON.stringify(pageAccessTime))
    })
  }

  handleCloseModal = () => {
    this.setState({
      isModalOpen: false
    })
  }

  handleSubmit = (form, valid, errors) => {
    if (valid) {
      let guardiansLvl = [
        {
          highestEducationalAttainment: form.parentGuardian1EduLvl,
          sequenceNumber: 1
        }
      ]
      if (form.parentGuardian2EduLvl !== '') {
        guardiansLvl.push({
          highestEducationalAttainment: form.parentGuardian2EduLvl,
          sequenceNumber: 2
        })
      }

      const newPersonalDetails = {
        ...this.state.personalDetails,
        disabilityIndicator: form.disabilityIndicator,
        disabilityTypes:
          form.disabilityIndicator === 'N'
            ? []
            : form.disability.map(disability => ({
                disabilityType: typeof disability === 'object' ? disability.value : disability
              })),
        disabilityContactIndicator: form.disabilityIndicator !== 'Y' ? 'N' : form.contactInd,
        birthCountry: form.countryOfBirth,
        entryYear: form.countryOfBirth !== Country.Australia ? (!!form.yearOfArrival ? form.yearOfArrival : '0') : '0',
        homeLanguage: form.englishOnlyAtHome === 'Y' ? '0001' : form.language,
        valueAlpha17:
          form.year12InAustralia === 'Y'
            ? form.residencySuburbYear12
            : this.state.countryCodes.find(country => {
                return country.countryCode === `${form.countryOfResidenceYear12}`
              }).description,
        valueAlpha18: form.year12InAustralia === 'Y' ? form.residencyPostcodeYear12 : 'OS-' + `${form.countryOfResidenceYear12}`,
        studentGuardiansEduLvl: guardiansLvl,
        educationalBackgrounds: [{ educationType: form.highestPriorEducationAchieved }],
        schoolingLevelCompleted: form.isSecondaryEducationCompleted === '2' ? form.levelLeftSchool : '02',
        schoolingLevelCompletedYear: form.yearLeftSchool,
        year12Year: form.isSecondaryEducationCompleted === '2' && form.levelLeftSchool === '12' ? form.yearLeftSchool : '',
        indigenousOrigin: form.indigenousOrigin,
        visaType: form.visaType,
        visaSubType: form.visaSubType
      }

      this.setState({
        saving: true
      })

      putSonePersonalDetails(newPersonalDetails)
        .then(() => {
          this.setState({
            saving: false
          })
          this.progressForm()
        })
        .catch(({ response: { status, data: { errorCode, errorMessage } } }) => {
          this.setState({
            saving: false
          })

          if (status === 400) {
            alert(errorMessage)
          } else {
            alert('Unable to save additional details.')
          }
        })
    } else {
      const failedFieldName = Object.keys(errors).find(errorKey => {
        return errors[errorKey];
      });
      if (failedFieldName) {
        const failedField = window.document.querySelector(`[name=${failedFieldName}]`);
        if (failedField) {
          const rect = failedField.getBoundingClientRect();
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const clientHeight = document.documentElement.clientHeight;
          const offsetTop = rect.top + scrollTop - (clientHeight / 2) + (rect.height / 2);
  
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        } else {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }

  progressForm = () => {
    const currentStepIndex = getStepIndexByUrl(this.props.location.pathname)

    updateStepProgress(currentStepIndex)
    updateDBStepProgress(currentStepIndex)

    this.props.history.push(getStepByIndex(currentStepIndex + 1).url)
  }

  mergeStudentDetails = (studentDetails, soneParentsEducationLevels, soneLevelLeftSchoolList, soneCountryCodeList) => {
    let formDetails = {}
    formDetails.dateOfBirth = studentDetails.dateOfBirth
    formDetails.disabilityIndicator = studentDetails.disabilityIndicator

    /** If not answered, allow selection */
    formDetails.indigenousOrigin = studentDetails.indigenousOrigin === 'X' || studentDetails.indigenousOrigin === 'NA' ? '' : studentDetails.indigenousOrigin

    formDetails.stuCitizenCd = studentDetails.stuCitizenCd

    formDetails.visaType = !studentDetails.visaType || studentDetails.visaType === 'NA' ? '' : studentDetails.visaType
    formDetails.visaSubType = !studentDetails.visaSubType || studentDetails.visaSubType === 'NA' ? '' : studentDetails.visaSubType
    formDetails.isVisaRequired = ResidencyType.VisaRequired.includes(studentDetails.stuCitizenCd)
    formDetails.isVisaAlreadySubmitted = !!formDetails.visaType && !!formDetails.visaSubType
    formDetails.visaQuestionResponse = !!formDetails.visaType && !!formDetails.visaSubType ? 'Y' : ''

    if (studentDetails.disabilityIndicator && studentDetails.disabilityTypes.length > 0) {
      formDetails.disability = studentDetails.disabilityTypes.map(disability => disability.disabilityType)
    }

    formDetails.contactInd = studentDetails.disabilityContactIndicator

    formDetails.countryOfBirth = studentDetails.birthCountry
    if (studentDetails.birthCountry !== Country.Australia && !!studentDetails.entryYear) {
      formDetails.yearOfArrival = `${studentDetails.entryYear}`
    }

    //formDetails.language = studentDetails.homeLanguage
    formDetails.language = ''
    if (studentDetails.homeLanguage === '0001') {
      formDetails.englishOnlyAtHome = 'Y'
    } else {
      formDetails.englishOnlyAtHome = 'N'
    }

    // valueAlpha18 is OS then its Overseas or if it is not OS and if it is not null then it in Australia

    formDetails.residencyPostcodeYear12 = studentDetails.valueAlpha18
    if (formDetails.residencyPostcodeYear12 !== '' && formDetails.residencyPostcodeYear12.includes('OS')) {
      formDetails.year12InAustralia = 'N'
      let countryCode = formDetails.residencyPostcodeYear12.split('-')[1]
      formDetails.countryOfResidenceYear12 =
        countryCode === undefined
          ? ''
          : soneCountryCodeList.some(countryObject => {
              return countryObject.countryCode === countryCode
            })
          ? countryCode
          : ''
    } else if (formDetails.residencyPostcodeYear12 != '') {
      formDetails.residencySuburbYear12 = studentDetails.valueAlpha17
      formDetails.year12InAustralia = 'Y'
    }

    if (studentDetails.studentGuardiansEduLvl && studentDetails.studentGuardiansEduLvl.length > 0) {
      let studentGuardiansEduLvls1 = studentDetails.studentGuardiansEduLvl.filter(({ sequenceNumber }) => sequenceNumber === 1)
      let studentGuardiansEduLvls2 = studentDetails.studentGuardiansEduLvl.filter(({ sequenceNumber }) => sequenceNumber === 2)

      if (studentGuardiansEduLvls1.length > 0) {
        let refernceDataFilteredForParent1 = soneParentsEducationLevels.filter(parentEduLvl => parentEduLvl.code === studentGuardiansEduLvls1[0].highestEducationalAttainment)

        formDetails.parentGuardian1EduLvl = refernceDataFilteredForParent1.length > 0 ? studentGuardiansEduLvls1[0].highestEducationalAttainment : ''
      }
      if (studentGuardiansEduLvls2.length > 0) {
        let refernceDataFilteredForParent2 = soneParentsEducationLevels.filter(parentEduLvl => parentEduLvl.code === studentGuardiansEduLvls2[0].highestEducationalAttainment)

        formDetails.parentGuardian2EduLvl = refernceDataFilteredForParent2.length > 0 ? studentGuardiansEduLvls2[0].highestEducationalAttainment : ''
      }
    }

    if (studentDetails.educationalBackgrounds && studentDetails.educationalBackgrounds.length > 0) {
      formDetails.highestPriorEducationAchieved = studentDetails.educationalBackgrounds[0].educationType
    } else {
      formDetails.highestPriorEducationAchieved = ''
    }
    let levelLeftSchoolValidCode =
      studentDetails.schoolingLevelCompleted !== '' &&
      soneLevelLeftSchoolList.some(levelLeftSchool => {
        return levelLeftSchool.schoolLevelCode === studentDetails.schoolingLevelCompleted
      })
        ? studentDetails.schoolingLevelCompleted
        : ''
    formDetails.isSecondaryEducationCompleted = studentDetails.schoolingLevelCompleted === '02' ? '1' : levelLeftSchoolValidCode !== '' ? '2' : ''
    formDetails.levelLeftSchool = levelLeftSchoolValidCode
    formDetails.yearLeftSchool = `${studentDetails.schoolingLevelCompletedYear}`

    return formDetails
  }

  render() {
    return (
      <div className="page page_fullWidth form form_additional_details">
        <div className="info-link">
          <p>
            <button className="btn-link" onClick={() => this.setState({ isModalOpen: true })}>
              <Info className="btn-point-events" /> Why do I need to provide additional details?
            </button>
          </p>
        </div>

        <div className="mobile-margin">
          {!this.state.formLoaded ? (
            <Loading />
          ) : (
            <AdditionalDetailsForm
              saving={this.state.saving}
              values={this.state.form}
              handleSubmit={this.handleSubmit}
              countryCodes={this.state.countryCodes}
            />
          )}
        </div>
        {/*end mobile margin*/}

        <DrupalModal className="modal-lg" slug="additional-details-information" isOpen={this.state.isModalOpen} handleCloseModal={this.handleCloseModal} />
      </div>
    )
  }
}
